import currency from 'common/filters/currency';

function getBoxPrice(box) {
  return box.use_price_in_usd
    ? currency(box.price_in_usd, 0, true)
    : currency(box.price);
}

export default getBoxPrice;
